import React, { useState, useContext } from "react";
import { QuizContext } from "../../../assets/context/index";
import "./styled.css";

const questions = [
  {
    option:
      "a) Growth & Performance; Customer experience & design; Martech & Analytics",
    correct: true,
  },
  {
    option:
      "b) Comportamento do consumidor & insights ágeis; Estratégia e inteligência de Marca; Customer experience & design",
    correct: false,
  },
  {
    option:
      "c) Martech & Analytics; Growth & Performance; Comportamento do consumidor & insights ágeis",
    correct: false,
  },
  {
    option:
      "d) Estratégia e inteligência de Marca; Martech & Analytics; Growth & Performance",
    correct: false,
  },
  {
    option:
      "e) Customer experience & design; Estratégia e inteligência de Marca; Conteúdo & Mídia",
    correct: false,
  },
];

export default function Question8(props) {
  const { t } = useContext(QuizContext);
  const { setQuestionSelected, checkAnswers } = props;
  const [optionSelected, setOptionSelected] = useState("");

  function selectOption(option) {
    setOptionSelected(option.option);

    setQuestionSelected((state) => {
      return {
        ...state,
        question8: {
          title:
            "Quando for abordar a pessoa responsável por canais digitais, quais ofertas devem ser levadas?",
          option: option.option,
          correct: option.correct,
          order: 8
        },
      };
    });
  }
  return (
    <div style={{ marginTop: 30 }}>
      <h5 style={{ textAlign: "center" }}>
        {t(
          "Quando for abordar a pessoa responsável por canais digitais, quais ofertas devem ser levadas?"
        )}
      </h5>

      <div className="div-options-question-ste">
        {questions.map((e, i) => (
          <a
            key={i}
            className={`option-question-ste ${
              optionSelected === e.option && "selected-option-question-ste"
            } ${checkAnswers && (e.correct ? "check-true" : "check-false")}`}
            onClick={() => {
              if (!checkAnswers) {
                selectOption(e);
              }
            }}
          >
            {t(e.option)}
          </a>
        ))}
      </div>
    </div>
  );
}
